import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { MDText } from 'i18n-react';
import sampleSize from 'lodash/sampleSize';

import {
	triggerAiCompanionExampleChatClickedEvent,
	triggerAiCompanionExampleChatLoadedEvent,
} from 'Services/analytics/events/aiCompanionEvents';

import LocalTexts from '../../AiCompanion.texts';

import { EXAMPLE_CHATS } from './exampleChats.data';

import styles from './ExampleChats.module.scss';

const LocalT = new MDText(LocalTexts);

const EXAMPLE_CHAT_COUNT = 3;

const handleExampleChatClick = (query: string, onSelectChat: (query: string) => void) => {
	triggerAiCompanionExampleChatClickedEvent({ exampleChat: query });
	onSelectChat(query);
};

interface ExampleChatsProps {
	onSelectChat: (query: string) => void;
}

export const ExampleChats: FC<ExampleChatsProps> = ({ onSelectChat }) => {
	const [suggestions, setSuggestions] = useState<string[]>([]);

	useEffect(() => {
		const chats = sampleSize(EXAMPLE_CHATS, EXAMPLE_CHAT_COUNT);
		setSuggestions(chats);
		triggerAiCompanionExampleChatLoadedEvent({ exampleChats: chats });
	}, []);

	if (!suggestions.length) {
		return null;
	}

	return (
		<div className={styles.wrapper}>
			<h3 className={styles.title} id="example-chats-label">
				{LocalT.translate('exampleChats.title')}
			</h3>
			<ul aria-labelledby="example-chats-label" className={styles.list} role="list">
				{suggestions.map((suggestion) => (
					<li key={suggestion}>
						<button
							className={styles.chatItem}
							onClick={() => handleExampleChatClick(suggestion, onSelectChat)}
							type="button"
						>
							{suggestion}
						</button>
					</li>
				))}
			</ul>
		</div>
	);
};
